import React from 'react'
import LogoutButton from './dashboardsComponents/LogoutButton'

function StaffDashboard() {
  return (
    <>
    <div>StaffDashboard</div>
    <LogoutButton/>
    </>
  )
}

export default StaffDashboard